import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
export interface CustomerSite {
  name: string;
  address: string;
  imageUrl: string;
}
@Component({
  selector: 'app-customer-site-card',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './customer-site-card.component.component.html',
  styleUrl: './customer-site-card.component.component.scss',
})
export class CustomerSiteCardComponentComponent {
  @Input() site: CustomerSite | null = null;
}
